import { AutogenModelEdiTemplateDetail, AutogenRowEdiTemplateDetail } from "./autogen/AutogenModelEdiTemplateDetail";

export class ModelEdiTemplateDetail extends AutogenModelEdiTemplateDetail<RowEdiTemplateDetail> {
	constructor() {
		super(RowEdiTemplateDetail);
	}
}

export class RowEdiTemplateDetail extends AutogenRowEdiTemplateDetail {
}